import { render, staticRenderFns } from "./ChatView.vue?vue&type=template&id=5e990708&scoped=true"
import script from "./ChatView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChatView.vue?vue&type=style&index=0&id=5e990708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e990708",
  null
  
)

export default component.exports